import { GrfqBbo } from '#/unified-rfqs/entities/grfq/bbo';
import { GrfqLeg } from '#/unified-rfqs/entities/grfq/domain';
import { getOppositeSide } from '#/unified-rfqs/ui/rfqs/quotes-functions';
import { getProduct } from '#/products/domain';
import { TwoWayValue } from '../form-reducer';

export interface LegPriceView {
  readonly bid: string;
  readonly ask: string;
  readonly key: string;
  readonly markPrice: string;
  readonly markPriceIv: string;
  readonly placeholder: string;
  readonly precision: number;
  readonly side: 'BUY' | 'SELL';
}

export interface LegsPricesView {
  readonly legs: readonly LegPriceView[];
  readonly isLoading: boolean;
}

export default function legsPricesView(
  rawLegs: readonly TwoWayValue[],
  bbo: GrfqBbo | null,
  legs: readonly GrfqLeg[],
  isLegPricesLoading: boolean,
  side: 'BUY' | 'SELL',
): LegsPricesView {
  const processLegInput = createLegInputProcessor(bbo, legs, side);
  return {
    legs: rawLegs.map(processLegInput),
    isLoading: isLegPricesLoading,
  };
}

const PLACEHOLDER = '-';
function createLegInputProcessor(
  bbo: GrfqBbo | null,
  legs: readonly GrfqLeg[],
  side: 'BUY' | 'SELL',
) {
  return function processLegInput(
    [bid, ask]: TwoWayValue,
    index: number,
  ): LegPriceView {
    const leg = legs[index]!;
    const { pricePrecision } = getProduct(leg.product_code);
    return {
      bid,
      ask,
      side: side === 'BUY' ? leg.side : getOppositeSide(leg.side),
      placeholder: PLACEHOLDER,
      markPrice: bbo?.leg_prices[index]?.mark_price ?? '-',
      markPriceIv: bbo?.leg_prices[index]?.mark_price_iv ?? '',
      key: `leg-input-price-${index}`,
      precision: pricePrecision,
    };
  };
}
